import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tab', 'content', 'action']
  static values = {
    active: { type: Number, default: 0 },
    syncUrl: { type: Boolean, default: true }
  }

  connect () {
    if (this.syncUrlValue) {
      const tabParam = new URLSearchParams(window.location.search).get('tab')
      if (tabParam !== null) this.activeValue = parseInt(tabParam)
    }
    this.showTab()
  }

  select (event) {
    this.activeValue = parseInt(event.currentTarget.dataset.index)
    if (this.syncUrlValue) {
      const url = new URL(window.location)
      url.searchParams.set('tab', this.activeValue)
      window.history.replaceState({}, '', url)
    }
    this.showTab()
  }

  showTab () {
    this.contentTargets.forEach((content) => content.setAttribute('hidden', ''))

    const activeContent = this.contentTargets.find((content) => {
      return parseInt(content.dataset.index) === this.activeValue
    }) ?? this.contentTargets[0]

    if (!activeContent) return

    activeContent.removeAttribute('hidden')
    const visibleIndex = parseInt(activeContent.dataset.index)

    this.tabTargets.forEach((tab) => {
      const selected = parseInt(tab.dataset.index) === visibleIndex
      tab.setAttribute('aria-selected', selected ? 'true' : 'false')
    })

    this.actionTargets.forEach((action) => {
      if (parseInt(action.dataset.index) === visibleIndex) {
        action.removeAttribute('hidden')
      } else {
        action.setAttribute('hidden', '')
      }
    })
  }
}
